import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { IExperimentScreenLot, State } from 'business/models/Models';
import { hasModifyAccess } from 'utils/accessRights';
import React, { useEffect, useState } from 'react';
import Lot from './Lot';
interface Props {
  expData: ExperimentDtoClient;
  setSelectedLot: (lot: IExperimentScreenLot) => void;
  deleteLot: (lot: IExperimentScreenLot) => void;
}
export default function LotsManager({ expData, setSelectedLot, deleteLot }: Props) {
  const [lots, setLots] = useState<IExperimentScreenLot[]>();
  const canModify = hasModifyAccess(expData.accessRightName);
  useEffect(() => {
    const screenLots =
      expData.info && expData.info.screenLots.filter((s) => s.state !== State.Deleted);
    setLots(screenLots);
  }, [expData]);
  return (
    <div
      id={'screenlot-lotsmanager-wrapper'}
      className="h-[60%] 2xl:h-[60%] 4xl:h-[68%] overflow-auto"
    >
      {lots &&
        lots.map((l) => (
          <Lot
            key={`lot_${l.id}`}
            lot={l}
            setSelectedLot={setSelectedLot}
            deleteLot={deleteLot}
            canModify={canModify}
          />
        ))}
    </div>
  );
}
